import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PetitionShareCountsQuery, PetitionShareCountsQueryVariables } from './api.graphql';
import { PetitionShareCounts } from './api.graphql';
import type { ShareCount } from './types';

export type PetitionShareCountsResult = {
	totalShareCount: number;
	totalShareCountLocalized: string;
	shareCountsByChannel: ShareCount[];
};

export async function getPetitionShareCounts({
	slugOrId,
	utilityContext,
}: {
	slugOrId: string;
	utilityContext: UtilityContext;
}): Promise<PetitionShareCountsResult> {
	const { gql, errorReporter } = utilityContext;

	const { data, requestId } = await gql.fetch<PetitionShareCountsQuery, PetitionShareCountsQueryVariables>({
		query: PetitionShareCounts,
		variables: { slugOrId },
		rejectOnError: true,
	});

	if (!data.petition) {
		const error = new Error('Petition not found');
		void errorReporter.report({ error, context: { requestId }, params: { slugOrId } });
		throw error;
	}

	const { shareCountsByChannel } = data.petition;

	if (shareCountsByChannel.__typename === 'ShareCountsByChannelError') {
		const error = new Error(shareCountsByChannel.message);
		void errorReporter.report({ error, context: { requestId }, params: { slugOrId } });
		throw error;
	}

	const countsByChannel: ShareCount[] = shareCountsByChannel.countsByChannel.map((item) => ({
		channel: item.channel,
		count: item.count,
	}));

	return {
		totalShareCount: shareCountsByChannel.totalCount,
		totalShareCountLocalized: shareCountsByChannel.totalCountLocalized,
		shareCountsByChannel: countsByChannel,
	};
}
